import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import store from './src/store/configureStore';
import createHistory from "history/createBrowserHistory";
import fonts from './src/styles/fonts.css'

export const replaceRouterComponent = ({ history }) => {
    const ConnectedRouterWrapper = ({ children }) => (
        <Provider store={store}>
            <Router history={history}>{children}</Router>
        </Provider>
    )
    return ConnectedRouterWrapper
}


// WEBPACK FOOTER //
// ./gatsby-browser.js